import _Api from '@/api/_Api';
import { CurrenciesInterface } from '@/interfaces/Currencies';

export class DictionariesApi extends _Api {
   static async dictionaries(): Promise<any> {
      const response = await this.http().get('dictionaries');
      return response.data;
   }

   static async allObjects(): Promise<any> {
      const response = await this.http().get('dictionaries/all-usable-data');
      return response.data;
   }

   static async currencies(): Promise<CurrenciesInterface> {
      const response = await this.http().get('dictionaries/currencies');
      return response.data;
   }

   static async tarification(): Promise<any> {
      const response = await this.http().get('dictionaries/tarification');
      return response.data;
   }

   static async vat(): Promise<any> {
      const response = await this.http().get('dictionaries/vat');
      return response.data;
   }

   static async beneficiaries(): Promise<any> {
      const response = await this.http().get('dictionaries/beneficiaries');
      return response.data;
   }

   static async beneficiary_account(id: number): Promise<any> {
      const response = await this.http().get('dictionaries/beneficiaries/' + id);
      return response.data;
   }
}
